import React from "react";
import { Grid, Tooltip, Typography } from "@material-ui/core";

import Button from "../../../../../components/elements/Button";
import classes from "../../CampaignsDashboard.module.scss";

type LandingPageViewModeProps = {
  landingPage: string;
  changeMode: () => void;
};

const LandingPageViewMode = ({ landingPage, changeMode }: LandingPageViewModeProps) => {
  const hasUrl = Boolean(landingPage?.trim());

  return (
    <Grid className={classes.landingPageContainer}>
      {hasUrl ? (
        <Tooltip title={landingPage}>
          <Typography className={classes.landingPageLinkWrap} component="div" variant="body2">
            <a href={landingPage} target="_blank" rel="noopener noreferrer">
              {landingPage}
            </a>
          </Typography>
        </Tooltip>
      ) : (
        <Typography className={classes.landingPageLinkWrap} component="div" variant="body2" color="textSecondary">
          —
        </Typography>
      )}
      <Button onClick={changeMode}>Edit</Button>
    </Grid>
  );
};

export default LandingPageViewMode;
